function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { PageBaseComponent } from "../../library/cms/page-components";
import EditIcon from "../../library/cms/edit-icon";
import { MediaManagerController } from "../../library/cms/media-manager";
import { Image, H3Title } from "../../library/cms/content-components";
import { TinyEditable } from "../../library/cms/editor";
export default class extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onTitle1Change", title => {
      this.state.component.content.title1 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle2Change", title => {
      this.state.component.content.title2 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle3Change", title => {
      this.state.component.content.title3 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle4Change", title => {
      this.state.component.content.title4 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onTitle5Change", title => {
      this.state.component.content.title5 = title;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile1Selected", files => {
      this.state.component.content.image1 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile2Selected", files => {
      this.state.component.content.image2 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile3Selected", files => {
      this.state.component.content.image3 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile4Selected", files => {
      this.state.component.content.image4 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile5Selected", files => {
      this.state.component.content.image5 = files[0];
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFile6Selected", files => {
      this.state.component.content.image6 = files[0];
      this.setState(this.state.component);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onGetContent(d) {
    var content = {
      image1: this.state.component.content.image1,
      image2: this.state.component.content.image2,
      image3: this.state.component.content.image3,
      image4: this.state.component.content.image4,
      image5: this.state.component.content.image5,
      image6: this.state.component.content.image6,
      title1: this.state.component.content.title1,
      title2: this.state.component.content.title2,
      title3: this.state.component.content.title3,
      title4: this.state.component.content.title4,
      title5: this.state.component.content.title5,
      html1: this.editor1 ? this.editor1.getContent() : this.state.component.content.html1,
      html2: this.editor2 ? this.editor2.getContent() : this.state.component.content.html2,
      html3: this.editor3 ? this.editor3.getContent() : this.state.component.content.html3,
      html4: this.editor4 ? this.editor4.getContent() : this.state.component.content.html4
    };
    var data = {
      key: this.props.contentKey,
      content: content
    };
    return data;
  }

  onToggleOn() {
    if (!this.applyZIndex) {
      this.applyZIndex = true;
      this.forceUpdate();
    }
  }

  render() {
    var cls1 = 'row-2-img-1';
    var cls2 = 'row-2-img-2';
    var cls5 = 'content-row row-5';

    if (this.applyZIndex) {
      cls1 += ' z-index';
      cls2 += ' z-index';
      cls5 += ' z-index';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "content-grid margin-top two"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-row row-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-text"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title1,
      onChange: this.onTitle1Change,
      cls: "italic"
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html1,
      active: this.state.component.active,
      ref: ref => this.editor1 = ref
    })), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image1,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile1Selected,
      ref: ref => this.image1 = ref
    })), /*#__PURE__*/React.createElement("div", {
      className: "content-row overflow row-2 relative"
    }, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image2,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile2Selected,
      cls: cls1,
      ref: ref => this.image2 = ref
    }), /*#__PURE__*/React.createElement("div", {
      className: "row-text top flex-1"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title2,
      onChange: this.onTitle2Change,
      cls: "italic"
    }), /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html2,
      active: this.state.component.active,
      cls: "row-body-text",
      ref: ref => this.editor2 = ref
    }), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image3,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile3Selected,
      cls: cls2,
      ref: ref => this.image3 = ref
    }))), /*#__PURE__*/React.createElement("div", {
      className: "content-row-full-width"
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-header-backdrop"
    }, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title3,
      onChange: this.onTitle3Change,
      cls: "italic"
    })), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image4,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile4Selected,
      ref: ref => this.image4 = ref
    })), /*#__PURE__*/React.createElement("div", {
      className: "content-row row-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-text"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title4,
      onChange: this.onTitle4Change,
      cls: "italic"
    })), /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html3,
      active: this.state.component.active,
      cls: "row-body-text",
      ref: ref => this.editor3 = ref
    })), /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image5,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile5Selected,
      ref: ref => this.image5 = ref
    })), /*#__PURE__*/React.createElement("div", {
      className: cls5
    }, /*#__PURE__*/React.createElement(Image, {
      media: this.state.component.content.image6,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFile6Selected,
      ref: ref => this.image6 = ref
    }), /*#__PURE__*/React.createElement("div", {
      className: "row-text"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(H3Title, {
      active: this.state.component.active,
      title: this.state.component.content.title5,
      onChange: this.onTitle5Change,
      cls: "italic"
    })), /*#__PURE__*/React.createElement(TinyEditable, {
      content: this.state.component.content.html4,
      active: this.state.component.active,
      ref: ref => this.editor4 = ref
    }))));
  }

}